module.exports = __webpack_public_path__ + "img/empty.e563ec43.png";